// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__183b-","section":"section__2w07a","feedback":"feedback__3_ran","title":"title__2FVaj","feedbackGrid":"feedbackGrid__1DUBw","feedbackImageWrapper":"feedbackImageWrapper__GWr79","imageWrapper":"imageWrapper__1-6eI","image":"image__3ylGC","feedbackMobile":"feedbackMobile__20I-g"};


//////////////////
// WEBPACK FOOTER
// ./components/feedback/style.styl
// module id = zocL
// module chunks = 0